module.exports = __webpack_public_path__ + "static/media/skyllen-logo.ead055be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/skyllen-logo.png
// module id = 377
// module chunks = 0